/**
 * Shared step-index enums for the two Tour instances that make up the LSA guided tour
 * (the list page's LargeSiteScreenTutorial and the map page's LssFromMapTutorial), plus derived
 * step counts used to display one continuous "X / Y" progress number across both pages.
 */

export const LIST_STEPS = {
  NAV: 0,
  LIBRARY: 1,
  FILTERS: 2,
  START_RUN: 3,
  REVIEW: 4,
  ADVANCED: 5,
  RISKIEST_POINT: 6,
  USAGE: 7,
  RUN_ANALYSIS: 8,
  PROCESSING: 9,
  COMPLETED: 10,
  GENERATING_SUMMARY: 11,
  SUMMARY_GENERATED: 12,
  VIEW_RESULTS: 13,
  DOWNLOAD_AGGREGATED: 14,
  DOWNLOAD_POINT_LEVEL: 15,
  POINT_LEVEL_MODAL: 16,
  DOWNLOAD_METADATA: 17,
  ACTIONS_MENU: 18,
  EDIT_MODAL: 19,
  DELETE_MODAL: 20,
} as const;

export const MAP_STEPS = {
  LOCATE: 0,
  DRAW_BOUNDARY_START: 1,
  DRAW_BOUNDARY_FINISH: 2,
  DRAW_BOUNDARY_EDIT: 3,
  DRAW_BOUNDARY_DELETE: 4,
  AREA_LIMIT: 5,
  NAME_POLYGON: 6,
  GRID_ADD: 7,
  GRID_DELETE: 8,
  GRID_MOVE: 9,
  GRID_LIMITS: 10,
  CONFIRM_SETTINGS: 11,
  ASSET_SETTINGS: 12,
  FINANCIAL_SETTINGS: 13,
  PROCEED_TO_REVIEW: 14,
} as const;

export const LIST_STEP_COUNT = Object.keys(LIST_STEPS).length;
export const MAP_STEP_COUNT = Object.keys(MAP_STEPS).length;

/** Number of Stage-1 (list page) steps shown before the map-page handoff. */
export const STAGE1_STEP_COUNT = LIST_STEPS.REVIEW;

/** Total steps shown across the whole tour (Stage 1 + Stage 2, Stage 3 reuses Stage 1's Tour instance). */
export const TOTAL_TOUR_STEPS = LIST_STEP_COUNT + MAP_STEP_COUNT;
